import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ModuleWithProviders } from '@angular/core';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { AutocompleteSearchComponent } from './autocomplete-search/autocomplete-search.component';
import { BarLoaderComponent } from './bar-loader/bar-loader.component';
import { CircularLoaderComponent } from './circular-loader/circular-loader.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { FilePickerComponent } from './file-picker/file-picker.component';
import { CustomerFormComponent, CustomerLinksFormComponent, CustomerPreferencesFormComponent, OrganisationFormComponent, OrganisationPreferencesFormComponent, ResetFormComponent } from './forms/index';
import { MultiItemInputComponent } from './forms/multi-item-input/multi-item-input.component';
import { RoleDirective } from './has-role/has-role.directive';
import { StaffFormComponent } from './forms/staff/staff-form.component';
import { GraphsComponent } from './graphs/graphs.component';
import { ImportComponent } from './import/import.component';
import { InviteComponent } from './invite/invite.component';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PhotoPickerItemComponent } from './photo-picker/photo-picker.component';
import { ProfileImageComponent } from './profile-image/profile-image.component';
import { RowResultComponent } from './row-result/row-result.component';
import { SELECTORS } from './selectors/index';
import { SentResetComponent } from './sent-reset/sent-reset.component';
import { AppSettings } from './settings/app-settings.service';
import { SidenavComponent } from './sidenav/sidenav.component';
import { CsvPreviewComponent } from './tables/csv-preview/csv-preview.component';
import { DataListCellPlaceholderDirective, DataListCellRendererDirective, DataListSimpleCellComponent, DataListTableComponent } from './tables/data-list-table/data-list-table.component';
import { CustomerFilesTableComponent, CustomerTeamTableComponent, OrganisationsTableComponent } from './tables/index';
import { MemoCategoriesTableComponent } from './tables/memo-categories/memo-categories-table.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { RestartModalComponent } from './services/app-restart/restart-modal.component';
import { AvatarComponent } from './avatar/avatar.component';
import { ImageLoaderComponent } from './image-loader/image-loader.component';
import { RatingComponent } from './rating/rating.component';
import { FeedbackComponent } from './feedback/feedback.component';
/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */
var COMPONENTS = [
    AvatarComponent,
    AnnouncementsComponent,
    BarLoaderComponent,
    CircularLoaderComponent,
    ConfirmationDialogComponent,
    CsvPreviewComponent,
    CustomerFilesTableComponent,
    CustomerFormComponent,
    CustomerLinksFormComponent,
    CustomerPreferencesFormComponent,
    CustomerTeamTableComponent,
    DataListTableComponent,
    DataListCellRendererDirective,
    DataListCellPlaceholderDirective,
    DataListSimpleCellComponent,
    EditProfileComponent,
    FeedbackComponent,
    FilePickerComponent,
    GraphsComponent,
    RoleDirective,
    ImageLoaderComponent,
    ImportComponent,
    InviteComponent,
    LoginComponent,
    MemoCategoriesTableComponent,
    MultiItemInputComponent,
    NavbarComponent,
    OrganisationFormComponent,
    OrganisationPreferencesFormComponent,
    OrganisationsTableComponent,
    PhotoPickerItemComponent,
    ProfileImageComponent,
    RatingComponent,
    ResetFormComponent,
    RestartModalComponent,
    RowResultComponent,
    SentResetComponent,
    SidenavComponent,
    StaffFormComponent,
    AutocompleteSearchComponent,
    ToolbarComponent
].concat(SELECTORS);
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule,
            providers: [AppSettings, { provide: 'Window', useValue: window }]
        };
    };
    return SharedModule;
}());
export { SharedModule };
